import React from 'react'
import { setGuideSettingsDialogShortcutsDisabled } from '@/lib/keyboard/dialog-shortcuts'

/** Suspends the editor's keyboard shortcuts while the guide settings dialog is open. */
export function useGuideDialogShortcuts(open: boolean): void {
  React.useEffect(() => {
    setGuideSettingsDialogShortcutsDisabled(open)

    return () => {
      setGuideSettingsDialogShortcutsDisabled(false)
    }
  }, [open])
}
